<h1>Jahresabschluss</h1>

<h2>Upload Jahresabschluss</h2>

@for (notification of notifications; track notification; let i = $index) {
    <elem-msg-line [notification]="notification" (click)="deleteMessage(i)"></elem-msg-line>
}

<div class="gridContainer dataGrid formGrid fitGrid">

    <div class="row">
        <div class="cell grid-100">
            <div class="upload">
                <div class="uploadZone" #dragOverBox>
                    <input #fileInput
                           type="file"
                           name="f_upload"
                           id="f_upload">
                    <label for="f_upload"><strong>Datei wählen</strong> oder hierher ziehen.</label>
                </div>
                <div class="uploadFiles">
                    @if (fileQueue.length !== 0) {
                        <ul class="uploadEd">
                            @for (ufile of fileQueue; track ufile; let i = $index) {
                                <li
                                    (click)="deleteUpload(i)"
                                    [class.uploadRunning]="running==true && done!=true"
                                >
                                    <progress class="file" max="100" [value]="uploadedPercent[i]">{{ ufile.name }}</progress>
                                    <div class="file">{{ ufile.name }} ({{ ufile.size | bytes2Mega }} MB)</div>
                                </li>
                            }
                        </ul>
                    }
                </div>
                @if (done) {
                    <div class="uploadMessage">Vielen Dank. Wir haben Ihre Datei(en) erhalten.</div>
                }
            </div>
        </div>
    </div>

    <div class="row">
        <div class="cell grid-25"></div>
        <div class="cell grid-50"></div>
        <div class="cell grid-25">
            @if (fileQueue.length !== 0 && !done && !running) {
                <elem-button
                    class="expand"
                    (click)="startUpload()">
                    Senden
                </elem-button>
            }
        </div>
    </div>

</div>
